import * as Location from 'expo-location';
import { updateAmplitudeUserAttributes } from 'features/profile/utils/analytics';

import { isNativeIOS } from 'utils/environment';

export const updateUserLocationPermissionStatus = async () => {
  const { status } = await Location.getForegroundPermissionsAsync();
  if (!status) {
    return;
  }
  if (isNativeIOS()) {
    updateAmplitudeUserAttributes({ 'IOS Location Permissions': status });
  } else {
    updateAmplitudeUserAttributes({ 'Android Location Permissions': status });
  }
};
